var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.971,
    height: 17.065,
    viewBox: "0 0 15.971 17.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_16945449851552644365",
    "data-name": 16945449851552645000,
    transform: "translate(-3.285 -2.4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_224_",
    cx: 2.441,
    cy: 2.441,
    r: 2.441,
    transform: "translate(8.871 8.492)",
    fill: "none",
    stroke: "#0bd19f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_242_",
    d: "M18.487,7.495l-.61-1.057a1.22,1.22,0,0,0-1.667-.447l-.321.186a1.831,1.831,0,0,1-2.746-1.585V4.22A1.22,1.22,0,0,0,11.922,3H10.7a1.22,1.22,0,0,0-1.22,1.22v.371A1.831,1.831,0,0,1,6.736,6.177l-.321-.186a1.22,1.22,0,0,0-1.667.447l-.61,1.057a1.22,1.22,0,0,0,.447,1.667l.321.186a1.831,1.831,0,0,1,0,3.171l-.321.186a1.22,1.22,0,0,0-.447,1.667l.61,1.057a1.22,1.22,0,0,0,1.667.447l.321-.186a1.831,1.831,0,0,1,2.746,1.585v.371a1.22,1.22,0,0,0,1.22,1.22h1.22a1.22,1.22,0,0,0,1.22-1.22v-.371a1.831,1.831,0,0,1,2.746-1.585l.321.186a1.22,1.22,0,0,0,1.667-.447l.61-1.057A1.22,1.22,0,0,0,18.04,12.7l-.321-.186a1.831,1.831,0,0,1,0-3.171l.321-.186A1.22,1.22,0,0,0,18.487,7.495Z",
    fill: "none",
    stroke: "#0bd19f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2d1f9129f4612b3050f81abc48cd8b9c.svg";
export { ForwardRef as ReactComponent };